import { GTagEventNameType, GTagEventParamsType } from './types';

export const ObjectIsNotEmpty = (obj: any) => {
  return obj && Object.keys(obj).length > 0 && obj.constructor === Object;
};

export const trackEvent = (
  eventName: GTagEventNameType,
  eventParams: GTagEventParamsType
) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};
